import 'babel-polyfill'
import Vue from 'vue'
import axios from 'axios'
Vue.prototype.$axios = axios
import VueAxios from 'vue-axios'


import Vuex from 'vuex'
Vue.use(Vuex)
import VueResource from 'vue-resource'
import ElementUI from 'element-ui'

// import 'element-ui/lib/theme-chalk/index.css' // 采用cdn加速时注释掉该行
// import 'font-awesome/css/font-awesome.min.css' // 采用cdn加速时注释掉该行
//import 'normalize.css'

import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
//import AppLayout from '@/layouts/app-layout.vue'

import htmlToPdf from '@/utils/htmlToPdf'
Vue.use(htmlToPdf)
import $ from 'jquery'
Vue.config.productionTip = false
Vue.use(VueResource)
Vue.use(ElementUI, {size: 'small'})

axios.interceptors.request.use(config => {
    config.headers.common = {
      'Authorization': 'Bearer '+store.state.loginInfo.jwtToken
	}
	return config;
})
//Vue.component('app-layout', AppLayout)
// 路由预处理，未登录一律跳到登录页面
router.beforeEach((to, from, next) => {
	if (store.getters.loginInfo || to.path == "/login") {
		next();
	} else {
		next("/login");
	}
});

/*-----------------替换系统函数实现---------------------*/
// 替换系统自带的日期格式化函数, 换成yyyy-MM-dd HH:mm:ss格式
Date.prototype.oldToString = Date.prototype.toString;
Date.prototype.toString = function () {
	const f = i => i < 10 ? '0' + i : "" + i;
	return `${this.getFullYear()}-${f(this.getMonth() + 1)}-${f(this.getDate())}`
		+ ` ${f(this.getHours())}:${f(this.getMinutes())}:${f(this.getSeconds())}`;
}
// 替换系统自带的格式化JSON的格式, 换成yyyy-MM-dd HH:mm:ss格式
Date.prototype.toJSON = Date.prototype.toString;

const _fmtPat = /\{\}/g;
String.prototype.fmt = function () {
	const args = arguments;
	let idx = 0;
	return this.replace(_fmtPat, m => args[idx++]);
}

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js